import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type Add2Props = IconComponentBaseProps;

export const Add2 = ({ className, width = 24, height = 24, fill = defaultTheme.mantineColors.gray[7] }: Add2Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7277_5845"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7277_5845)">
        <path
          d="M11.9998 20.5C11.7871 20.5 11.609 20.4281 11.4655 20.2843C11.3218 20.1406 11.25 19.9625 11.25 19.75V12.75H4.25C4.0375 12.75 3.85942 12.6781 3.71575 12.5343C3.57192 12.3904 3.5 12.2122 3.5 11.9998C3.5 11.7871 3.57192 11.609 3.71575 11.4655C3.85942 11.3218 4.0375 11.25 4.25 11.25H11.25V4.25C11.25 4.0375 11.3219 3.85942 11.4658 3.71575C11.6096 3.57192 11.7878 3.5 12.0003 3.5C12.2129 3.5 12.391 3.57192 12.5345 3.71575C12.6782 3.85942 12.75 4.0375 12.75 4.25V11.25H19.75C19.9625 11.25 20.1406 11.3219 20.2843 11.4658C20.4281 11.6096 20.5 11.7878 20.5 12.0003C20.5 12.2129 20.4281 12.391 20.2843 12.5345C20.1406 12.6782 19.9625 12.75 19.75 12.75H12.75V19.75C12.75 19.9625 12.6781 20.1406 12.5343 20.2843C12.3904 20.4281 12.2122 20.5 11.9998 20.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
